<template>
  <div class="auth-container">
    <el-dialog :lock-scroll="true" v-if="globalDialog.registerVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="globalDialog.registerVisible"  @close="removeToken()">
      <Register :isDialog="true" v-on:success="close" class="passport-dialog"></Register>
    </el-dialog>
  </div>
</template>

<script>
import Register from './Register'

export default {
  name: 'RegisterDialog',
  components: {
    Register: Register
  },
  computed: {
    globalDialog () {
	    return this.$store.state.globalDialog
    }
  },
  data () {
    return {
    }
  },
  methods: {
    close () {
      this.$store.commit('hideGlobalDialog', 'registerVisible')
    },
    removeToken (){
      this.$localStorage.remove('token')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/RegisterDialog.vue